import { Text } from "../../../../../library/text";
import { InfinitySpin } from "react-loader-spinner";
import {
  LoaderContainer,
  SpinnerWrapper,
  TextWrapper,
  ContentWrapper,
  ExitWrapper,
} from "./styled";
import Button from "../../../../../library/button";
import { Link } from "react-router-dom";

const EditorLoader = () => {
  return (
    <LoaderContainer>
      <ExitWrapper>
        <Link to="/dashboard/transcripts">
          <Button color="blue" variant="regular" icon="back">
            Gå tilbake
          </Button>
        </Link>
      </ExitWrapper>
      <ContentWrapper>
        <SpinnerWrapper>
          <InfinitySpin width="200" color="#2f8de4" />
        </SpinnerWrapper>
        <TextWrapper>
          <Text color="dark">Laster editor..</Text>
        </TextWrapper>
      </ContentWrapper>
    </LoaderContainer>
  );
};

export default EditorLoader;
